import { HeadMetadata } from "@hub/models/metadata/head-metadata";
import { BannerConfig } from "@hub/models/ui/banner-config";
import { Breadcrumb } from "@hub/models/ui/breadcrumb";
import { NavigationFolders } from "@hub/models/ui/navigation-folders";
import { PageConfig } from "@hub/models/ui/page-config";
import { LabsResultsPageLayout } from "@hub/ui/layouts/labs-results-page-layout";
import React from "react";

interface AllLabsPageProps {
  navigationFolders?: NavigationFolders;
  breadcrumbs?: Breadcrumb[];
  headMetadata?: HeadMetadata;
  pageConfig: PageConfig;
  bannerConfig: BannerConfig;
}

export const AllLabsPage: React.FC<AllLabsPageProps> = ({
  navigationFolders,
  breadcrumbs,
  headMetadata,
  pageConfig,
  bannerConfig,
}) => {
  return (
    <LabsResultsPageLayout
      pageConfig={pageConfig}
      bannerConfig={bannerConfig}
      breadcrumbs={breadcrumbs}
      headMetadata={headMetadata}
      searchBarMessage={"Search labs"}
      navigationFolders={navigationFolders}
    />
  );
};
